import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { NavLink } from 'react-router-dom'
import { useNavigationBar } from './NavigationBarContext'
import { NavigationLink } from './useExtranetLinks'

const StyledNavLinkStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;

  border: 0;
  outline: 0;
  padding: 0 var(--spacing-small);

  font-family: var(--font-family-secondary);
  font-size: 14px;
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;

  color: var(--color-white);

  &:visited {
    color: var(--color-white);
  }

  &:hover {
    cursor: pointer;
  }
`

const StyledNavLink = styled(NavLink)`
  ${StyledNavLinkStyles}
`

const StyledNavButton = styled.button`
  ${StyledNavLinkStyles}
`

type NavigationLinkProps = {
  link: NavigationLink
}

export const NavigationBarLink = ({ link }: NavigationLinkProps) => {
  const hasSublinks = !!link.children && link.children.length > 0

  const { openMegaMenu, clearMegaMenu } = useNavigationBar()

  if (!hasSublinks && !!link.path)
    return (
      <li>
        <StyledNavLink
          onClick={() => clearMegaMenu()}
          to={link.path}
        >
          {link.label}
        </StyledNavLink>
      </li>
    )

  return (
    <li>
      <StyledNavButton onClick={() => openMegaMenu(link)}>{link.label}</StyledNavButton>
    </li>
  )
}
